module.exports = __webpack_public_path__ + "static/media/status-pago.88f4e413.svg";